import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Card, Checkbox, Grid, Table} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

const {
  fetchDealersList,
} = Actions;

const ComboDealersTab = ({comboDealers, handleComboDealers}) => {
  const dealersList = useSelector((state) => state.dealersList.list);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchDealersList());
  }, []);

  const getCheckedDealerValue = (dealer) => {
    const t = comboDealers.map((x) => x.identification).includes(dealer.identification);
    return t;
  };

  const handleDealerCheckbox = (e, input, dealer) => {
    e.preventDefault();
    handleComboDealers(dealer, input.checked);
  };

  return (
    <Grid>
      <Grid.Row columns={2}>
        <Grid.Column>
          <Card fluid raised>
            <Table textAlign='center'>
              <Table.Header>
                <Table.HeaderCell />
                <Table.HeaderCell content='RUC' />
                <Table.HeaderCell content='Nombre' />
              </Table.Header>
              <Table.Body>
                {dealersList.map((dealer, i) => {
                  return (
                    <Table.Row key={i}>
                      <Table.Cell content={<Checkbox checked={getCheckedDealerValue(dealer)}
                        onChange={(e, input) => handleDealerCheckbox(e, input, dealer)} />} />
                      <Table.Cell content={dealer.identification} />
                      <Table.Cell content={dealer.name} />
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          </Card>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default ComboDealersTab;
